import { BaseObject } from '../base-object';

export abstract class Compound extends BaseObject {
  // Nothing here, though
}
